module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="popup-wrapper newsletter-popup">\n\n    <a href="#" class="close">&times;</a>\n\n    <img src="static/img/newsletter-heart-envelope.png">\n    <h1>Vielen Dank für Ihre Anmeldung zum spreenautischen Newsletter</h1>\n\n    <div class="text">\n        Wir freuen uns sehr darüber und würden Sie gerne ab sofort auf dem Laufenden erhalten.\n        Soeben hat unser System Ihnen eine E-Mail mit einem Bestätigungslink an Ihre E-Mail-Adresse\n        <b>' +
((__t = ( this.data.email )) == null ? '' : __t) +
'</b> geschickt. Bitte klicken Sie auf den Link um die Anmeldung zu unserem\n        Newletter zu bestätigen.\n    </div>\n\n    <div class="signature">\n        Ihr Spreenauten Team\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./frontend/js/templates/newsletter-popup.ejs
// module id = 413
// module chunks = 1